import type { OrderPaymentStatusEnum } from '@ztechapps/common.contract'
import { isOrderStatusEditable } from './isOrderStatusEditable'
import { isPaymentOutstanding } from './isPaymentOutstanding'

export const shouldShowCheckout = (status: string, paymentStatus: OrderPaymentStatusEnum): boolean =>
  isPaymentOutstanding(paymentStatus) && isOrderStatusEditable(status)
